import React from 'react';
import { graphql } from 'gatsby';
import { ContactList as ContactListComponent } from '../../ContactList';

export const ContactList = ({ data, ...rest }) => <ContactListComponent {...data} {...rest} />;

export const ContactListQuery = graphql`
  fragment ContactList on KFH_UmbracoContactListComponentType {
    divisions {
      name
      id
      content
      divisionAddresses {
        name
        line1
        line2
        town
        postcode
        telephone
        email
        contactName
      }
    }
  }
`;
